export interface IUIEditedCellData {
    newValue?: any;
    oldData: any;
}
